export default {
  primary: '#18447e',
  primaryTrans: 'rgba(24, 68, 126, 0.8)',
  secondary: '#e09b4c',
  yellow: '#f7c443',
  skyblue: '#5683b2',
  skyBlueTrans: 'rgba(86, 131, 178, 0.8)',
  white: '#fff',
  black: '#000',
  offwhite: '#f8f8ff',
  medium: '#6e6969',
  light: '#f8f4f4',
  dark: '#333333',
  danger: '#ff5252',
  red: '#c13232',
  green: '#417527',
  lightGreen: 'rgba(152, 195, 135, 1.0)',
  inputBackground: '#e3e3e3',
  gray: '#808080',
  newGray: 'rgb(230, 230, 230)',
  recommend: '#d7eff0',
};
